// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__-u9UM","inputWrap":"Table_inputWrap__26tmq","col":"Table_col__2PSRY","bmiTooltip":"Table_bmiTooltip__1Wj3C"};